import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { compose, graphql } from 'react-apollo';
import styled from 'styled-components';
import Loader from '../common/Loader';
import Error from '../common/Error';
import Button from '../common/Button';
import EtranResults from './EtranResults';
import EtranQuery from './query/EtranQuery';
import DocumentQuery from '../documents/queries/DocumentQuery'
import UpdateEtranInfo from './query/UpdateEtranInfo';
import SubmitEtranApi from './query/SubmitEtranApi';
import { useQuery } from '@apollo/react-hooks'

const EtranContainer = styled.div`
  margin: 20px;
`;
const TitleContainer = styled.div`
  height: 35px;
  display: flex;
  justify-content: space-between;
`;
const PageTitle = styled.div`
  display: inline-flex;
  height: 35px;
  color: #56565a;
  font-family: 'Open Sans';
  font-size: 24px;
  font-weight: 600;
  line-height: 35px;
`;
const TitleButtonContainer = styled.div`
  display: inline-flex;
  height: 35px;
`;
const Line = styled.div`
  box-sizing: border-box;
  height: 1px;
  border: 1px solid #dbdbdc;
  margin-top: 30px;
  margin-bottom: 10px;
`;
const SubmitButton = Button.extend`
  background: #cc6900;
  height: 35px;
  color: #ffffff;
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  border: 1px solid rgba(57, 57, 58, 0.2);
  margin-right: 20px;
`;

class EtranLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: this.props.initLoading || false,
      error: false,
      isAPIConfirmationOpen: false,
      isAPISubmissionInProgress: false,
      isEtranAvailable: false,
      api_response_status: '',
      disabled_submit_hover: false,
      etran_process: props.paycheck_protection ? 'submit_via_api' : 'manual',
      enable_submit_btn: false,
      etran_info: {},
      entityId: '',
      appNumber: '',
      errors: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      data: { loan },
    } = nextProps;

    if (loan !== undefined) {
      this.setState({
        loading: false,
        appNumber: loan.appNumber,
        entityId: loan.business.rid,
        isEtranAvailable: this.isEtranAvailableForLoan(loan),
        etran_info:
          Object.keys(this.state.etran_info).length > 0
            ? this.state.etran_info
            : loan.etran
            ? this.getEtranInfo(loan.etran)
            : {},
        api_response_status: this.isErrorStatus(loan.etran) ? "error" : "",
        errors: this.isErrorStatus(loan.etran)
          ? this.getErrorStatus(loan.etran?.errorStatus)
          : [],
      });
    }
  }

  isEtranAvailableForLoan = (loan) => {
    const { paycheck_protection, document } = this.props;
    const { etran } = loan;
    let isEtranAvailableForLoan = false;

    if (paycheck_protection && etran) {
      const { externalId, sbaStatus } = etran;

      isEtranAvailableForLoan = externalId
        ? sbaStatus
        : isEtranAvailableForLoan;
    } else if (!paycheck_protection) {
      isEtranAvailableForLoan =
        etran !== null || document.files.length > 0;
    }

    return isEtranAvailableForLoan;
  };

  isErrorStatus = (data) => {
    if (!data) {
      return false;
    }

    return data.sbaStatus === 'error';
  };

  getErrorStatus = (errorStatus) => {
    let result = [];
    result.push(errorStatus);

    return result;
  };

  getEtranInfo = (data) => {
    return {
      etran_score: data.etranScore,
      score_date: data.scoreDate?.split('T')[0],
      plp_authorization_number: data.plpAuthorizationNumber,
      plp_authorization_date: data.plpAuthorizationDate?.split('T')[0],
      external_id: data.externalId,
      sba_status: data.sbaStatus,
    };
  };

  setSubmitButtonDisabled = (enable_submit_btn, etran_info) => {
    this.setState({ enable_submit_btn });
    this.setState({ etran_info });
  };
  validInput = (etran_info) => {
    const isValidData = ['etran_score', 'score_date'].every((input) => {
      const value = etran_info[input]
      return typeof value === 'string' && value.length > 1
    })

    return isValidData && this.props.document.files.length > 0
  }
  handleEtranInfoSuccess = () => {
    const {
      props: { cavirs_result_screen },
      state: { appNumber },
    } = this;

    this.setState({
      api_response_status: 'success',
      enable_submit_btn: false,
    });

    if (cavirs_result_screen) {
      //redirect so loan can go to caivrs page
      window.location.href = `/admin/loans/${appNumber}/caivr?stage=5`;
    } else {
      //reload so loan can go to Etran Verified
      window.location.reload();
    }
  };

  submitAndCommitEtran = async () => {
    const { updateEtranInfo, loanId } = this.props;
    const {
      etran_info: {
        etran_score,
        plp_authorization_number,
        plp_authorization_date,
        score_date,
      },
    } = this.state;

    await updateEtranInfo({
      variables: {
        input: {
          loanId,
          etranScore: parseInt(etran_score),
          etranScoreDate: new Date(score_date).toISOString(),
          plpAuthorizationNumber: !plp_authorization_number
            ? null
            : parseFloat(plp_authorization_number),
          plpAuthorizedDate: !plp_authorization_date
            ? null
            : new Date(plp_authorization_date).toISOString(),
        },
      },
      update: () => {
        this.handleEtranInfoSuccess();
      },
    });
  };

  renderActionButtons = () => {
    const { etran_info, api_response_status } = this.state
    const disabled =
      !this.validInput(etran_info) || api_response_status === 'success'

    return (
      <TitleButtonContainer>
        <SubmitButton
          disabled={disabled}
          onClick={this.submitAndCommitEtran}
        >
          Save
        </SubmitButton>
      </TitleButtonContainer>
    );
  };

  renderEtranResultsScreen = () => {
    const {
      api_response_status,
      etran_process,
      etran_info,
      entityId,
      appNumber,
      errors,
    } = this.state;
    const {
      loanId,
      paycheck_protection,
      documentBucketOptions,
      document,
    } = this.props;

    return (
      <EtranResults
        api_response_status={api_response_status}
        etran_process={etran_process}
        loanId={loanId}
        setSubmitButtonDisabled={this.setSubmitButtonDisabled}
        validInput={this.validInput}
        document={document}
        etranInfo={etran_info}
        entityId={entityId}
        appNumber={appNumber}
        is_paycheck_protection={paycheck_protection}
        errors={errors}
        documentBucketOptions={documentBucketOptions}
      />
    );
  };

  render() {
    const { loading, error } = this.state;
    const container = document.getElementById('e_tran');

    if (loading) {
      return <Loader number={4} />;
    }
    if (error) {
      return <Error />;
    }
    return ReactDOM.createPortal(
      <EtranContainer>
        <TitleContainer>
          <PageTitle>E-Tran</PageTitle>
          {this.renderActionButtons()}
        </TitleContainer>
        <Line />
        {this.renderEtranResultsScreen()}
      </EtranContainer>,
      container
    );
  }
}

export { EtranLanding };

const EtranLandingWithMutations = compose(
  graphql(UpdateEtranInfo, {
    name: 'updateEtranInfo',
  }),
  graphql(SubmitEtranApi, {
    name: 'submitEtranApi',
  })
)(EtranLanding)

const DocumentFetcher = ({ etranData, ...props }) => {
  const documentId = etranData.loan.etranResultsDocument.rid

  const { data, loading, error } = useQuery(DocumentQuery, {
    variables: { rid: documentId },
  })

  if (error) return <Error />
  if (loading) return <Loader number={4} />

  return (
    <EtranLandingWithMutations
      {...props}
      data={etranData}
      document={data.document}
    />
  )
}

const EtranFetcher = (props) => {
  const loanId = parseInt(props.loanId, 10)

  const { data, loading, error } = useQuery(EtranQuery, {
    variables: { rid: loanId },
  })

  if (error) return <Error />
  if (loading) return <Loader number={4} />

  return <DocumentFetcher etranData={data} {...props} />
}

export default EtranFetcher
